import { render, staticRenderFns, recyclableRender, components } from "./release.vue?vue&type=template&id=6085bf4e&scoped=true&"
var renderjs
import script from "./release.vue?vue&type=script&lang=js&"
export * from "./release.vue?vue&type=script&lang=js&"
import style0 from "./release.vue?vue&type=style&index=0&id=6085bf4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085bf4e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/square/release.vue"
export default component.exports